import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow } from "../../types/BFL/Funktionskontroll";
import { IModuleByggnadsdata, IModuleVentilationS } from "../../types/ModuleDatas";
import { logAndNotifyError } from "../logger";

//todo -> make class?!
export const bfl_J3_S = (): IBFModule => {
  const bfName = BFLType.BFL_J3_S;
  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    const funktionsKontroller: IKontrollResultRow[] = [];
    const driftOptimeringar: IKontrollResultRow[] = [];
    let data = {} as any;
    let dbg = {} as any;
    let error: any = undefined;

    const bH = bflHelper.bflHelper();

    //To be implemented!
    try {
      //Modules
      const moduleData = module.data as IModuleVentilationS;
      const byggnadsModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const byggnadModuleData = byggnadsModule?.data as IModuleByggnadsdata;

      //=IF(vSIn_ärSjälvdragsystemetHelaByggnaden="Nej";vsIn_betjänasAndel;1)
      const sJ3Betjäningsyta = moduleData.ärSjälvdragsystemetHelaByggnaden === "Nej" ? moduleData.betjänasAndel : 1;

      const genomsnittData = globalData.BFL_J3S.genomsnittligLuftomsättning;
      const genomsnittTakhöjd = genomsnittData.find((r) => r.Genomsnitt === "Takhöjd")?.Värde as number;
      const genomsnittOmsPerTimme = genomsnittData.find((r) => r.Genomsnitt === "Oms/timme")?.Värde as number;
      const genomsnittFaktorTidsenhet = genomsnittData.find((r) => r.Genomsnitt === "FaktorTidsenhet")?.Värde as number;

      const sJ3GenomsnittLuftomsättning = genomsnittFaktorTidsenhet > 0 ? (genomsnittTakhöjd * genomsnittOmsPerTimme) / genomsnittFaktorTidsenhet : 0;

      //=byggnadArea*sJ3GenomsnittLuftomsättning
      const sJ3FlödeFrånluft = byggnadModuleData.byggnadArea * sJ3GenomsnittLuftomsättning;
      const sJ3Driftfaktor = 100; //100% antagen
      const sJ3Gradtimmar = bimHandler.BIM_GradtimmarVärmeFörOrten;

      //=(sJ3FlödeFrånluft/1000)*BIM_DensitetLuft*BIM_Luft_Energimängd*sJ3Gradtimmar*sJ3Driftfaktor*sJ3Betjäningsyta
      const BIM_DensitetLuft = bimHandler.BIM_DensitetLuft;
      const BIM_Luft_Energimängd = bimHandler.BIM_Luft_Energimängd;
      const j3s_beräknadEnergiAnvändningPerÅr = (sJ3FlödeFrånluft / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * sJ3Gradtimmar * (sJ3Driftfaktor / 100) * (sJ3Betjäningsyta / 100);

      data = {
        export: {
          årligEnergiAnvändning: j3s_beräknadEnergiAnvändningPerÅr,
        },
      };

      const årligEnergiAnvändning = {
        årligEnergiAnvändning: j3s_beräknadEnergiAnvändningPerÅr,
      };

      const tabell1 = {
        sJ3Betjäningsyta,
        sJ3GenomsnittLuftomsättning,
        sJ3FlödeFrånluft,
        sJ3Driftfaktor,
        sJ3Gradtimmar,
        j3s_beräknadEnergiAnvändningPerÅr,
      };

      const GenomsnittligLuftomsättning = {
        genomsnittTakhöjd,
        genomsnittOmsPerTimme,
        genomsnittFaktorTidsenhet,
      };

      const BimVärden = {
        BIM_DensitetLuft,
        BIM_Luft_Energimängd,
      };

      dbg = { årligEnergiAnvändning, tabell1, GenomsnittligLuftomsättning, BimVärden };
    } catch (ex: any) {
      logAndNotifyError(ex);
      error = ex.toString();
    }
    return {
      bfName: BFLType.BFL_J3_S,
      funktionsKontroller: [],
      driftOptimeringar: [],
      data,
      note: "",
      error,
      debug: dbg,
    };
  };

  return { getResult, bfName };
};

const dflt = { bfl_J3_S };

export default dflt;
